const UnauthorizedPage = () => {
    return <h1>Access Denied. Please contact the administrator for assistance.</h1>;
};

export default UnauthorizedPage;